import * as React from 'react';
import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import OptionsView from '~common/form/options-edit-view';
import StyleView from '~common/form/style-edit-view';
import CustomMessagesView from '~common/form/messages-edit-view';
import ConditionalAttributesView from '~common/form/conditions-edit-view';
import PortalUser from '~common/lib/portal-user-context';
import {PredefinedField} from '~common/lib/types';
import {Theme} from '@mui/styles';

import {
  Grid,
  Typography,
  TextField,
  Checkbox,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  FormControlLabel,
  FormControl,
  Switch 
} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: '1rem'
  },
  subheading: {
    marginBottom: 15
  },
  instructions: {
    marginBottom: 15
  },
  formArea: {},
  formField: {
    width: '100%'
  },
  formFieldInner: {
    width: 'calc(100% - 15px)'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  field: PredefinedField;
  onFieldChange?: (field: PredefinedField) => void;
  onFieldDelete?: (field: PredefinedField) => void;
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  field: any;
  status: 'ready' | 'loading';
};

class FieldEditView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
 constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      field: props.field,
      status: 'loading'
    };
  }

 componentDidMount() {
    // Initiate loading here is any loading is required.  Do not forget to also implement in UNSAFE_componentWillReceiveProps also
    this.setState({status: 'ready'});
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>,
    oldProps: Props & WithStyles<keyof typeof styles>
  ) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also
    this.setState({field: newProps.field, status: 'ready'});
  }

  handleAttributeChange = (attribute: string) => (evt: any) => {
    const {field} = this.state;
    field[attribute] = evt.target.value;
    this.setState({field: field});
    if (this.props.onFieldChange) {
      this.props.onFieldChange(field);
    }
  };

  handleBooleanAttributeChange = (attribute: string) => (evt: any) => {
    const {field} = this.state;
    field[attribute] = evt.target.checked;
    this.setState({field: field});
    if (this.props.onFieldChange) {
      this.props.onFieldChange(field);
    }
  };

  handleCompositeAttributeChange = (attribute: string) => (value: any) => {
    // console.log('handleCompositeAttributeChange', attribute, value);
    const {field} = this.state;
    field[attribute] = value;
    this.setState({field: field});
    if (this.props.onFieldChange) {
      this.props.onFieldChange(field);
    }
  };

  handleGridAttributeChange = (attribute: string) => (evt: any) => {
    const {field} = this.state;
    if (!field.gridAttributes) {
      field.gridAttributes = {};
    }
    switch (attribute) {
      case 'xs':
      case 'sm':
      case 'md':
      case 'lg':
      case 'xl':
        try {
          field.gridAttributes[attribute] = parseInt(evt.target.value);
        } catch (e) {}
        break;
      case 'newRow':
        field.gridAttributes[attribute] = evt.target.checked;
        break;

      default:
        field.gridAttributes[attribute] = evt.target.value;
    }

    this.setState({field: field});

    if (this.props.onFieldChange) {
      this.props.onFieldChange(field);
    }

  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {status, field} = this.state;

    switch (status) {
      case 'loading':
        // TODO:
        return <LoadingView classes={{}} />;
        break;

      default:
        let lengthView: any = null;
        let optionsView: any = null;
        let autoSuggestURLView: any = null;
        let regexView: any = null;
        let valueView: any = null;
        let defaultValueView: any = null;
        let placeholderView: any = null;
        let allowedCharactersView: any = null;
        let dateView: any = null;
        let addressFieldAttributesView: any = null;

        // console.log("field.type", field.type)

        switch (field.type) {
          case 'Boolean':
            defaultValueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Default Value
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for boolean default values
                  </Typography>
                </div> */}
              </Grid>
            );
          case 'Text':
            lengthView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Length Limits
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for text length limits
                  </Typography>
                </div> */}
              </Grid>
            );

            optionsView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                 
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography className={classes.subheading} variant="subtitle1">
                      Options
                    </Typography>
                  </Grid>
                  {PortalUser.hasOneOfFeatures(['form_development']) && <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                  <TextField
                      className={classes.formField}
                      id="portalListOptionsKey"
                      name="portalListOptionsKey"
                      value={field.portalListOptionsKey || ''}
                      label="List Options Key"
                      onChange={this.handleAttributeChange('portalListOptionsKey')}
                      InputLabelProps={{
                        shrink: true
                      }}
                      helperText="If provided, options will be sourced from portal_list_options by key"
                    /></Grid>}

                </Grid>
               
                {(!field.portalListOptionsKey || field.portalListOptionsKey == "") && <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={field.allowOptionsFilter}
                        onChange={this.handleBooleanAttributeChange('allowOptionsFilter')}
                        value="allowOptionsFilter"
                        color="primary"
                        disabled={(field.options||[]).length == 0}
                      />
                    }
                    label="Allow option filtering."
                  />
                  <OptionsView
                    field={field}
                    onOptionsChange={this.handleCompositeAttributeChange(
                      'options'
                    )}
                  />
                  </Grid>}

              </Grid>
            );

            if (PortalUser.hasOneOfFeatures(['form_development'])) {
              autoSuggestURLView = (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    className={classes.subheading}
                    variant="subtitle1">
                    Auto Suggest URL
                  </Typography>
                  <div>
                    <Typography
                      className={classes.instructions}
                      variant="body1">
                      AutoSuggestURL directs the UI to use the URL to provide
                      autosuggest. The URL must adhere to the options data
                      structure and should accept a `term` querystring
                      parameter.
                    </Typography>
                    <TextField
                      className={classes.formField}
                      id="autoSuggestURL"
                      name="autoSuggestURL"
                      value={field.autoSuggestURL || ''}
                      label="AutoSuggestURL"
                      onChange={this.handleAttributeChange('autoSuggestURL')}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </div>
                </Grid>
              );
            }
            defaultValueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Default Value
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for text default values
                  </Typography>
                </div> */}
              </Grid>
            );
            placeholderView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  className={classes.formField}
                  id="placeholder"
                  name="placeholder"
                  value={field.placeholder || ''}
                  label="Placeholder"
                  onChange={this.handleAttributeChange('placeholder')}
                  InputLabelProps={{
                    shrink: true
                  }}
                  helperText="This is the text that will be shown to users prior to entering a value"
                />
              </Grid>
            );
            if (PortalUser.hasOneOfFeatures(['form_development'])) {
              regexView = (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextField
                    className={classes.formField}
                    id="regex"
                    name="regex"
                    value={field.regex || ''}
                    label="Regular Expression"
                    onChange={this.handleAttributeChange('regex')}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText="The regular expression to be user to validate content patterns."
                  />
                </Grid>
              );
            }
            if (PortalUser.hasOneOfFeatures(['form_development'])) {
              allowedCharactersView = (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextField
                    className={classes.formField}
                    id="allowedCharacters"
                    name="allowedCharacters"
                    value={field.allowedCharacters || ''}
                    label="Allowed Characters"
                    onChange={this.handleAttributeChange('allowedCharacters')}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText="If provided, entry in this field will be limited to these characters"
                  />
                </Grid>
              );
            }

            break;
          case "AddressField":
              addressFieldAttributesView = (
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Typography className={classes.subheading} variant="subtitle1">
                        Address Field Attributes
                      </Typography>
                    </Grid>

                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <FormControl component="fieldset">
                          <FormControlLabel
                            control={
                              <Routes
                                checked={field.showCountry}
                                onChange={this.handleBooleanAttributeChange(
                                  'showCountry'
                                )}
                                value="parse"
                                color="primary"
                              />
                            }
                            label="Show Country"
                          />
                        </FormControl>
                    </Grid> */}
                    {field.mode == "Required" && <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Typography className={classes.subheading} variant="subtitle1">
                        Required Fields
                      </Typography>
                    

                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requireAddress1}
                              onChange={this.handleBooleanAttributeChange(
                                'requireAddress1'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="Address 1"
                        />
                      </FormControl>
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requireAddress2}
                              onChange={this.handleBooleanAttributeChange(
                                'requireAddress2'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="Address 2"
                        />
                      </FormControl>
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requireCity}
                              onChange={this.handleBooleanAttributeChange(
                                'requireCity'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="City"
                        />
                      </FormControl>
                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requireState}
                              onChange={this.handleBooleanAttributeChange(
                                'requireState'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="State"
                        />
                      </FormControl>

                      <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requirePostalCode}
                              onChange={this.handleBooleanAttributeChange(
                                'requirePostalCode'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="Zip"
                        />
                      </FormControl>

                      {field.showCountry && <FormControl component="fieldset">
                        <FormControlLabel
                          control={
                            <Routes
                              checked={field.requireCountry}
                              onChange={this.handleBooleanAttributeChange(
                                'requireCountry'
                              )}
                              value="parse"
                              color="primary"
                            />
                          }
                          label="Country"
                        />
                      </FormControl>}
                    </Grid>}
                      
                    {PortalUser.hasOneOfFeatures(['form_development']) && <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                      <TextField
                          className={classes.formField}
                          id="portalListOptionsKey"
                          name="portalListOptionsKey"
                          value={field.portalListOptionsKey || ''}
                          label="State Options Key"
                          onChange={this.handleAttributeChange('portalListOptionsKey')}
                          InputLabelProps={{
                            shrink: true
                          }}
                          helperText="If provided, options for the state field will be sourced from portal_list_options by key"
                        />
                    </Grid>}
                      


                   
                </Grid>
              )
              break;
          case 'DateTime':
          case 'DateRange':
          case 'Date':
            dateView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className={classes.subheading} variant="subtitle1">
                  Date Limits
                </Typography>
                <Typography className={classes.instructions} variant="body1">
                  Date limits are set using a relative date expression that is
                  formed sign (+/-), amount and units (d, day, w, weeks, m,
                  months, etc). Examples include '-90d' (90 days in the past),
                  '2w' (two weeks in the future), etc.
                </Typography>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <TextField
                      className={classes.formFieldInner}
                      id="minDate"
                      name="minDate"
                      value={field.minDate || ''}
                      label="Min Date"
                      onChange={this.handleAttributeChange('minDate')}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <TextField
                      className={classes.formFieldInner}
                      id="maxDate"
                      name="maxDate"
                      value={field.maxDate || ''}
                      label="Max Date"
                      onChange={this.handleAttributeChange('maxDate')}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            );

            defaultValueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Default Value
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for date default values
                  </Typography>
                </div> */}
              </Grid>
            );
            break;
          case 'NumericRange':
		  //fallthrough
          case 'Number':
          //fallthrough
          case 'Numeric':
          //fallthrough
          case 'Currency':
            valueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Value Limits
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for numeric value limits
                  </Typography>
                </div> */}
              </Grid>
            );
            defaultValueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Default Value
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for numeric default values
                  </Typography>
                </div> */}
              </Grid>
            );

            optionsView = (<div>
              {PortalUser.hasOneOfFeatures(['form_development']) && <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                <TextField
                    className={classes.formField}
                    id="portalListOptionsKey"
                    name="portalListOptionsKey"
                    value={field.portalListOptionsKey || ''}
                    label="State Options Key"
                    onChange={this.handleAttributeChange('portalListOptionsKey')}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText="If provided, options for the state field will be sourced from portal_list_options by key"
                  />
              </Grid>}
              {(!field.portalListOptionsKey || field.portalListOptionsKey == "") && <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography className={classes.subheading} variant="subtitle1">
                  Options
                </Typography>
                <div>
                  <OptionsView
                    field={field}
                    onOptionsChange={this.handleCompositeAttributeChange(
                      'options'
                    )}
                  />
                </div>
              </Grid>}
            </div>);
            break;
          case 'VersionedDocument':
            defaultValueView = (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <Typography className={classes.subheading} variant="subtitle1">
                  Default Value
                </Typography>
                <div>
                  <Typography variant="body1">
                    TODO: Implement support for versioned documents
                  </Typography>
                </div> */}
              </Grid>
            );
        }

        // If this field has conditional attributes, formulate the react objects
        let gridAttributesView: any = null;

        if (!field.gridAttributes) {
          field.gridAttributes = {};
        }
        // We definitely have conditionals
        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          gridAttributesView = (
            <div>
              <Grid spacing={1} className={classes.formArea} container>
                <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                  <TextField
                    className={classes.formField}
                    id="xs"
                    name="xs"
                    value={field.gridAttributes.xs || ''}
                    label="xs"
                    onChange={this.handleGridAttributeChange('xs')}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                  <TextField
                    className={classes.formField}
                    id="sm"
                    name="sm"
                    value={field.gridAttributes.sm || ''}
                    label="sm"
                    onChange={this.handleGridAttributeChange('sm')}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                  <TextField
                    className={classes.formField}
                    id="md"
                    name="md"
                    value={field.gridAttributes.md || ''}
                    label="md"
                    onChange={this.handleGridAttributeChange('md')}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                  <TextField
                    className={classes.formField}
                    id="lg"
                    name="lg"
                    value={field.gridAttributes.lg || ''}
                    label="lg"
                    onChange={this.handleGridAttributeChange('lg')}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={4} md={2} lg={2} xl={1}>
                  <TextField
                    className={classes.formField}
                    id="xl"
                    name="xl"
                    value={field.gridAttributes.xl || ''}
                    label="xl"
                    onChange={this.handleGridAttributeChange('xl')}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={field.gridAttributes.newRow}
                        onChange={this.handleGridAttributeChange('newRow')}
                        value="newRow"
                        color="primary"
                      />
                    }
                    label="When visible, start a new row with the field."
                  />
                </Grid>
              </Grid>
            </div>
          );
        }

        // If this field has conditional attributes, formulate the react objects
        let conditionalAttributesView: any = null;

        if (!field.conditionalAttributes) {
          field.conditionalAttributes = [];
        }
        // We definitely have conditionals
        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          conditionalAttributesView = (
            <div>
              <ConditionalAttributesView
                field={field}
                onConditionalAttributesChange={this.handleCompositeAttributeChange(
                  'conditionalAttributes'
                )}
              />
            </div>
          );
        }

        let styleAttributesView: any = null;
        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          styleAttributesView = (
            <div>
              <StyleView
                style={field.styleAttributes}
                onStyleChange={this.handleCompositeAttributeChange(
                  'styleAttributes'
                )}
              />
            </div>
          );
        }

        let customRendererView: any = null;
        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          customRendererView = (
            <div>
              <Typography className={classes.instructions} variant="body1">
                This allows one to specify the custom renderer for the field.
                The customer renderer much be registered in the client
                application. If no customer renderer is found, the default
                rendering method will be used. Note: When a custom renderer is
                used, it is up to the developer to ensure that the custom
                renderer properly implements the field level restrictions and
                messaging controlled by the values above.
              </Typography>
              <Typography className={classes.instructions} variant="body1">
                Note: Custom renderers will only be presented in admin when in
                preview mode.
              </Typography>

              <TextField
                required={true}
                className={classes.formField}
                id="customRenderer"
                name="customRenderer"
                value={field.customRenderer || ''}
                label=""
                onChange={this.handleAttributeChange('customRenderer')}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </div>
          );
        }

        let customMessagesView: any = null;
        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          customMessagesView = (
            <CustomMessagesView
              field={field}
              onCustomMessagesChange={this.handleCompositeAttributeChange(
                'customMessages'
              )}
            />
          );
        }

        return (
          <div className={classes.container}>
            <Typography variant="body1">{field.comments}</Typography>
            <Grid spacing={3} className={classes.formArea} container>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <TextField
                  required={true}
                  id="key"
                  name="key"
                  value={field.key || ''}
                  label="Key"
                  onChange={this.handleAttributeChange('key')}
                  InputLabelProps={{
                    shrink: true
                  }}
                  disabled={!field.userDefined}
                  helperText="This is the unique key for the user defined field"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                <TextField
                  required={true}
                  id="title"
                  name="title"
                  value={field.title || ''}
                  label="Title"
                  onChange={this.handleAttributeChange('title')}
                  InputLabelProps={{
                    shrink: true
                  }}
                  helperText="This is the label that is dispayed for the user"
                />
              </Grid>
              {PortalUser.hasOneOfFeatures(['form_development']) &&
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                  <TextField
                    required={true}
                    id="path"
                    name="path"
                    value={field.path || ''}
                    label="Path"
                    onChange={this.handleAttributeChange('path')}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText="Sets the object path (eg. `/invoiceInfo/invoiceNbr` to which changes will be applied."
                  />
                </Grid>
              }
              {(PortalUser.hasOneOfFeatures(['form_development']) ||
                field.userDefined) && (
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                  {/*
                This is the mode.  We we presend a constrained list
              */}
                  <FormControl required className={classes.formControl}>
                    <InputLabel htmlFor="mode">Mode</InputLabel>
                    <Select
                      className={classes.formField}
                      value={field.mode || ''}
                      onChange={this.handleAttributeChange('mode')}
                      name="mode"
                      inputProps={{
                        id: 'mode'
                      }}>
                      <MenuItem value="Required">Required</MenuItem>
                      <MenuItem value="Optional">Optional</MenuItem>
                      <MenuItem value="Read Only">Read Only</MenuItem>
                      <MenuItem value="Display">Display Mode</MenuItem>
                      <MenuItem value="Hidden">Hidden</MenuItem>
                    </Select>
                    <FormHelperText>
                      This determines how the field is presented to the user.
                    </FormHelperText>
                  </FormControl>
                </Grid>
              )}
              {!field.legacy && (
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <TextField
                    className={classes.formField}
                    id="helpText"
                    name="helpText"
                    value={field.helpText || ''}
                    label="Help Text"
                    onChange={this.handleAttributeChange('helpText')}
                    InputLabelProps={{
                      shrink: true
                    }}
                    helperText="This is the text that will be displayed to the user to assist them with their entry."
                  />
                </Grid>
              )}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                    <TextField
                      className={classes.formField}
                      id="variant"
                      name="variant"
                      value={field.variant || ''}
                      label="Variant"
                      onChange={this.handleAttributeChange('variant')}
                      InputLabelProps={{
                        shrink: true
                      }}
                      helperText="Indicates to the rendering control which variant should be used (eg. Routes, Checkbox, etc.)"
                    />
                  </Grid>
                )}
              {!field.legacy &&
                field.type == 'VersionedDocument' &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                    <FormControl component="fieldset">
                      <FormControlLabel
                        control={
                          <Routes
                            checked={field.parse}
                            onChange={this.handleBooleanAttributeChange(
                              'parse'
                            )}
                            value="parse"
                            color="primary"
                          />
                        }
                        label="Parse document data at upload, if possible"
                      />
                    </FormControl>
                  </Grid>
                )}
              {!field.legacy &&
                field.type == 'VersionedDocument' &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                    <TextField
                      className={classes.formField}
                      id="acceptedDocumentTypes"
                      name="acceptedDocumentTypes"
                      value={field.acceptedDocumentTypes || ''}
                      label="Accepted Document Types"
                      onChange={this.handleAttributeChange(
                        'acceptedDocumentTypes'
                      )}
                      InputLabelProps={{
                        shrink: true
                      }}
                      helperText="A comma separated list of content types to support eg. `image/gif, image/jpeg`"
                    />
                  </Grid>
                )}
              {/*
                    These are type specific properties
                  */}
              {!field.legacy && placeholderView}
              {!field.legacy && allowedCharactersView}
              {!field.legacy && lengthView}
              {!field.legacy && defaultValueView}
              {!field.legacy && optionsView}
              {!field.legacy &&  addressFieldAttributesView}
              {!field.legacy && autoSuggestURLView}
              {!field.legacy && regexView}
              {!field.legacy && valueView}
              {!field.legacy && dateView}
              {/*
                    These are more advanced properties available for any type 
                  */}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography
                      className={classes.subheading}
                      variant="subtitle1">
                      Grid Attributes
                    </Typography>
                    {gridAttributesView}
                  </Grid>
                )}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {conditionalAttributesView}
                  </Grid>
                )}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {/* <Typography
                      className={classes.subheading}
                      variant="subtitle1">
                      Style Attributes
                    </Typography>
                    {styleAttributesView} */}
                  </Grid>
                )}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {customMessagesView}
                  </Grid>
                )}
              {!field.legacy &&
                PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography
                      className={classes.subheading}
                      variant="subtitle1">
                      Custom Renderer
                    </Typography>
                    {customRendererView}
                  </Grid>
                )}
            </Grid>
          </div>
        );
    }

    return null;
  }
}

export default withStyles(styles)(FieldEditView);
